import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import PrivateRoute from "@/components/PrivateRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import StocksPage from "@/pages/wrappers/StocksPage";
import ClustersPage from "@/pages/wrappers/ClustersPage";
import ProductsPage from "@/pages/wrappers/ProductsPage";
import FinancePage from "@/pages/wrappers/FinancePage";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import SupportPage from "@/pages/SupportPage";
import OzonApiGuide from "@/pages/OzonApiGuide";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminStats from "@/pages/admin/AdminStats";
import AdminUserCard from "@/pages/admin/AdminUserCard";

// React Query client with caching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // Данные "свежие" 5 минут
      gcTime: 30 * 60 * 1000,        // Кэш живёт 30 минут (gcTime = бывший cacheTime)
      refetchOnWindowFocus: false,   // Не перезагружать при фокусе окна
      retry: 1,                      // Одна повторная попытка при ошибке
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          
          {/* All protected routes with sidebar */}
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="stocks" element={<StocksPage />} />
            <Route path="clusters" element={<ClustersPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="finance" element={<FinancePage />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/ozon-api-guide" element={<OzonApiGuide />} />
            <Route path="profile" element={<Profile />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="admin" element={<AdminUsers />} />
            <Route path="admin/stats" element={<AdminStats />} />
            <Route path="admin/users/:userId" element={<AdminUserCard />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
